import { useAuth0 } from '@auth0/auth0-react';
import axios, { AxiosError } from 'axios';
import { useMutation, UseMutationOptions } from 'react-query';
import configuration from '../../configuration';
import { Schedule } from './useFetchSchedule';

export function useSaveSchedule(
    options?: Omit<
    UseMutationOptions<
      void,
      AxiosError,
      Schedule[]
    >,
    'mutationKey' | 'mutationFn'
  >,
) {
    const { getAccessTokenSilently } = useAuth0();
    return useMutation(
        async (request: Schedule[]) => {            
            const token = await getAccessTokenSilently();
            axios.post(`${configuration.apiUrl}/schedule`, request, {
                headers: {
                    'authorization': `bearer ${token}`
                }
            });

        }, options
    );
}